// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "form-dvuId";
var _4 = "container-258aO";
var _5 = "header-2ftGF";
var _6 = "description-s2iHT";
var _7 = "row-2lGnp";
var _8 = "main-3rbbn";
var _9 = "field_comment-97nb0";
var _a = "field-sigZ2";
var _b = "controls-1XVLK";
var _c = "submit-1f_Xw";
var _d = "button-3XZFy";
var _e = "button_checked-15NUa";
var _f = "warningModal-3DyXi";
var _10 = "label-3nAGr";
export { _1 as "__esModule", _2 as "mobile", _3 as "form", _4 as "container", _5 as "header", _6 as "description", _7 as "row", _8 as "main", _9 as "field_comment", _a as "field", _b as "controls", _c as "submit", _d as "button", _e as "button_checked", _f as "warningModal", _10 as "label" }
export default { "__esModule": _1, "mobile": _2, "form": _3, "container": _4, "header": _5, "description": _6, "row": _7, "main": _8, "field_comment": _9, "field": _a, "controls": _b, "submit": _c, "button": _d, "button_checked": _e, "warningModal": _f, "label": _10 }
